import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardShowroomIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.17 4.85001L13.65 0.500006C12.66 -0.159994 11.33 -0.159994 10.39 0.470006L2.76002 4.90001C1.78002 5.55001 1.21002 6.54001 1.21002 7.60001V16.4C1.21002 17.56 1.87002 18.67 2.81002 19.13L10.35 23.5C11.32 24.15 12.65 24.17 13.61 23.53L21.25 19.1C22.23 18.45 22.79 17.46 22.79 16.4V7.60001C22.79 6.45001 22.14 5.35001 21.17 4.85001ZM20.79 16.4C20.79 16.92 20.38 17.27 20.19 17.4L12.55 21.83C12.22 22.05 11.79 22.05 11.41 21.8L3.76002 17.37C3.45002 17.21 3.21002 16.8 3.21002 16.4V7.60001C3.21002 7.08001 3.62002 6.72001 3.81002 6.60001L11.45 2.17001C11.8 1.94001 12.24 1.97001 12.59 2.20001L20.18 6.60001C20.18 6.60001 20.22 6.62001 20.23 6.63001C20.54 6.79001 20.78 7.21001 20.78 7.61001V16.41L20.79 16.4Z"
        fill={color}
      />
      <path
        d="M16.8 8.64001L12.5 6.14C12.19 5.96 11.81 5.96 11.5 6.14L7.20001 8.64001C6.89001 8.82001 6.70001 9.15001 6.70001 9.50001V14.5C6.70001 14.86 6.89001 15.19 7.20001 15.36L11.5 17.86C11.81 18.04 12.19 18.04 12.5 17.86L16.8 15.36C17.11 15.18 17.3 14.85 17.3 14.5V9.50001C17.3 9.14001 17.11 8.81001 16.8 8.64001ZM11 15.26L8.70001 13.92V11.26L11 12.57V15.25V15.26ZM12 10.85L9.67001 9.52001L12 8.16L14.33 9.52001L12 10.85ZM15.3 13.92L13 15.26V12.58L15.3 11.27V13.93V13.92Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardShowroomIcon.displayName = 'BoardShowroomIcon';
